import { render, staticRenderFns } from "./FrameworkSideFilter.vue?vue&type=template&id=a38bc4f0&"
import script from "./FrameworkSideFilter.vue?vue&type=script&lang=js&"
export * from "./FrameworkSideFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports